import React, { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';

import Carousel from 'react-material-ui-carousel';
import { Box, CircularProgress, Container, Grow, Grid, Typography, Tabs, Tab, Button, Paper } from '@material-ui/core';
// import { Pagination, PaginationItem } from '@material-ui/lab'
// import { getPostsBySearch } from '../../actions/posts';
// import { useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import useStyles from './styles';
import Project from '../../Projects/Project/Project';
import { store } from '../../../index';
import { getProjectsBySearch, getProjects } from '../../../actions/projects';

import { useDispatch } from 'react-redux';
import useCommonStyles from '../../CommonStyle/commonStyle';




function Carousell(props: any) {
    const items = [
        {
            name: 'Aya Bouchiha',
            description: 'Full Stack Web Developer',
        },
        {
            name: 'John Doe',
            description: 'Author',
        },
        {
            name: 'Pitsu Coma',
            description: 'Math Student',
        },
    ];
    const [currentId, setCurrentId] = useState(null);
    type RootState = ReturnType<typeof store.getState>;
    const dispatch = useDispatch();
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    const search = '';
    // useEffect(() => {
    //         dispatch(getProjects(1));
        
    //   }, [dispatch]);
    //dispatch(getProjectsBySearch({ search, tags: [].join(',') }, 1));


    const { projects, isLoading } = useSelector((state: RootState) => state.projects);

    return (
        isLoading ? <CircularProgress /> : (
        <Carousel navButtonsAlwaysVisible={true} autoPlay={false}>
            {projects.map((project, index) => (
                <Grid item key={index} className={classes.projectGridContainer}>
                        <Project project={project} setCurrentId={setCurrentId}/>
                    </Grid>            ))}
        </Carousel>)
    );
}

const Item = ({ name, description }: any) => {
    return (
        <Paper>
            <h2>{name}</h2>
            <p>{description}</p>
            <Button>more info...</Button>
        </Paper>
    );
};

const ProjectCarousel = () => {

    const classes = useStyles();
    const commonClasses = useCommonStyles();


    return (
        <Container className={classes.projectsGridContainer}>
            <Carousell />

        </Container>

    )
};

export default ProjectCarousel;
